import { Feedback, OrganisationHeaderWithImage } from '@percent/lemonade';
import { OrganisationPreviewProps } from './OrganisationPreview.types';
import styles from './OrganisationPreview.module.scss';
import { useTranslation } from 'react-i18next';

export const OrganisationPreview = ({ organisation }: OrganisationPreviewProps) => {
  const { t } = useTranslation();
  const { name, countryCode, registryId, website, logo, address, postcode } = organisation;

  return (
    <div className={styles.organisationPreviewWrapper}>
      <div className={styles.organisationPreview} key={name} data-testid="organisation-preview">
        <OrganisationHeaderWithImage
          title={name}
          countryCode={countryCode}
          iconUrl={logo}
          website={website}
          registryId={t('typography.registryId', { registryId })}
        />
        <span className={styles.organisationPreviewAddress} data-testid="organisation-preview-address">
          {[address, postcode].filter(Boolean).join(', ')}
        </span>
      </div>
      <Feedback variant="default">{t('typography.organisationPreviewNote')}</Feedback>
    </div>
  );
};
